(function ($) {

    $(function () {

        function moveDeposit() {
            var deposit = $('#yith-wcdp-add-deposit-to-cart');
            var target = $('.single_variation_wrap');

            if (deposit.length && target.length) {
                target.prepend(deposit);
            }
        }

        moveDeposit();

        $('form.variations_form').on('found_variation', function() {
            setTimeout(moveDeposit, 50);
        });

        var bundleImageWrapper = $('.bundled_product_image');

        if (bundleImageWrapper.length < 1) {
            return;
        }

        bundleImageWrapper.magnificPopup({
            'delegate': 'a',
            'type': 'image',
            gallery: {
                enabled: false,
            },
            image: {
                titleSrc: 'alt',
            }
        });

    });

})(jQuery);